import React from "react";
import "./Pc.css";

const ProductCard = ({ 
    logo, 
    img, 
    alt, 
    title, 
    specs = [], 
    priceHT, 
    priceTTC, 
    optionText, 
    description,
    isPriceOnRequest // Nouvelle prop venant du backend
}) => {
    return (
        <div className="product-card">
            {logo && <img src={logo} alt="Logo" className="product-card__logo" />}

            <h2 className="product-card__title">{title}</h2>

            {img && <img src={img} alt={alt} className="product-card__img" />}

            {specs.length > 0 && (
                <ul className="product-card__specs">
                    {specs.map(({ icon, label }, i) => (
                        <li key={i} className="product-card__spec">
                            {icon && <img src={icon} alt="" className="product-card__icon" />}
                            <span>{label}</span>
                        </li>
                    ))}
                </ul>
            )}

            {/* Logique d'affichage du prix */}
            <div className="product-card__price-container">
                {isPriceOnRequest ? (
                    <span className="product-card__price-request">Prix sur demande</span>
                ) : (
                    (priceHT || priceTTC) && (
                        <div className="product-card__price">
                            {priceHT && <span className="ht">{priceHT}</span>}
                            {priceTTC && <span className="ttc">{priceTTC}</span>}
                        </div>
                    )
                )}
            </div>

            {optionText && <p className="product-card__option">{optionText}</p>}
            {description && <p className="product-card__description">{description}</p>}
        </div>
    );
};

export default ProductCard;